import { createSlice } from '@reduxjs/toolkit';
import { confirm_answers } from 'data/confirmAnswers';

const initialState = {
  advPropMax: false,
  advPropMin: false,
  automaticSalinityControl: confirm_answers[1].value,
  allEnabled: false,
  changeWifi: false,
  connectionValue: 0,
  currentStep: 0,
  delayAfterCal: {
    chlorinator: { value: false, delay: null },
    addPump: { value: false, delay: null },
  },
  dosingEnabled: false,
  enabledExternalSignal1: false,
  enabledExternalSignal2: false,
  enabledLowSalt: false,
  enabledTmanut: false,
  enabledPostBoost: false,
  enableOfa: false,
  enableChlorinatorOfa: false,
  enableAlarm: false,
  enableProximitySensor: false,
  hour: 0,
  isLoading: false,
  isChlorinatorAlarm: false,
  isSuccesfully: false,
  lowSalt: null,
  min: null,
  max: null,
  minLimit: null,
  maxLimit: null,
  minRotaz: 15,
  maxRotaz: 100,
  modomisura: null,
  ofaMinutes: 0,
  ofaChlorinatorMinutes: 0,
  openOfaModal: false,
  openOfaChlorinatorModal: false,
  openMaintenanceModal: false,
  phPriority: confirm_answers[1].value,
  polarizationCycleDuration: null,
  poolCover: {
    value: false,
    mode: 0,
    power: null,
  },
  pulsevol: 0,
  reboot: false,
  restart: false,
  referenceTemp: null,
  sliderActive: false,
  soundDuration: '',
  startupDelay: 0,
  tempValue: 0,
  temp: null,
  tempCoefficent: null,
  tmanut: null,
  winterModeAuto: { value: confirm_answers[1].value, temperature: null, unit: 1 },
  ice: {
    enabled: false,
    temperature: null,
    unit: 0,
  },
  overDosing: {
    enabled: false,
    value: null,
  },
  underDosing: {
    enabled: false,
    value: null,
  },
};

const deviceSettingsSlice = createSlice({
  name: 'deviceSettings',
  initialState,
  reducers: {
    decreaseStep(state) {
      state.currentStep--;
    },
    increaseStep(state) {
      state.currentStep++;
    },
    resetState() {
      return { ...initialState };
    },
    resetStepState(state) {
      state.currentStep = 0;
    },
    setAllEnabled(state, action) {
      state.allEnabled = action.payload;
    },
    setAutomaticSalinityControl(state, action) {
      state.automaticSalinityControl = action.payload;
    },
    setChangeWifi(state, action) {
      state.changeWifi = action.payload;
    },
    setConnectionValue(state) {
      state.connectionValue = state.connectionValue === 1 ? 0 : 1;
    },
    setDosingEnabled(state, action) {
      state.dosingEnabled = action.payload;
    },
    setEnabledExternalSignal1(state, action) {
      state.enabledExternalSignal1 = action.payload;
    },
    setEnabledExternalSignal2(state, action) {
      state.enabledExternalSignal2 = action.payload;
    },
    setEnabledChlorinatorOfa(state, action) {
      state.enableChlorinatorOfa = action.payload;
    },
    setEnabledOfa(state, action) {
      state.enableOfa = action.payload;
    },
    setEnabledAlarm(state, action) {
      state.enableAlarm = action.payload;
    },
    setHour(state, action) {
      state.hour = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsSucecsfully(state, action) {
      state.isSuccesfully = action.payload;
    },
    setMin(state, action) {
      state.min = Number(action.payload);
    },
    setMinLimit(state, action) {
      state.minLimit = Number(action.payload);
    },
    setMinRotaz(state, action) {
      state.minRotaz = Number(action.payload);
    },
    setMax(state, action) {
      state.max = Number(action.payload);
    },
    setMaxLimit(state, action) {
      state.maxLimit = Number(action.payload);
    },
    setMaxRotaz(state, action) {
      state.maxRotaz = Number(action.payload);
    },
    setOfaMinutes(state, action) {
      state.ofaMinutes = action.payload;
    },
    setOfaChlorinatorMinutes(state, action) {
      state.ofaChlorinatorMinutes = action.payload;
    },
    setOpenOfaModal(state, action) {
      state.openOfaModal = action.payload;
    },
    setOpenOfaChlorinatorModal(state, action) {
      state.openOfaChlorinatorModal = action.payload;
    },
    setPhPriority(state, action) {
      state.phPriority = action.payload;
    },
    setPulsevol(state, action) {
      state.pulsevol = Number(action.payload);
    },
    setRestart(state, action) {
      state.restart = action.payload;
    },
    setReboot(state, action) {
      state.reboot = action.payload;
    },
    setReferenceTemp(state, action) {
      state.referenceTemp = Number(action.payload);
    },
    setSliderActive(state, action) {
      state.sliderActive = action.payload;
    },
    setSoundDuration(state, action) {
      state.soundDuration = action.payload;
    },
    setStartupDelay(state, action) {
      state.startupDelay = Number(action.payload);
    },
    setTempCoefficent(state, action) {
      state.tempCoefficent = Number(action.payload);
    },
    setTemp(state, action) {
      state.temp = Number(action.payload);
    },
    setTempValue(state) {
      state.tempValue = state.tempValue === 1 ? 0 : 1;
    },
    setAdvPropMax(state, action) {
      state.advPropMax = action.payload;
    },
    setAdvPropMin(state, action) {
      state.advPropMin = action.payload;
    },
    setWinterModeAuto(state, action) {
      state.winterModeAuto = action.payload;
    },
    setWinterModeAutoValue(state, action) {
      state.winterModeAuto.value = action.payload;
    },
    setWinterModeAutoTemperature(state, action) {
      state.winterModeAuto.temperature = action.payload;
    },
    setWinterModeAutoUnit(state) {
      state.winterModeAuto.unit = state.winterModeAuto.unit === 1 ? 0 : 1;
    },
    setAutomaticPreset(state, action) {
      state.automaticPreset = action.payload;
    },
    setAutomaticPresetValue(state, action) {
      state.automaticPreset.value = action.payload;
    },
    setAutomaticPresetDuration(state, action) {
      state.automaticPreset.duration = action.payload;
    },
    setAutomaticPresetPower(state, action) {
      state.automaticPreset.power = action.payload;
    },
    setEnableProximitySensor(state, action) {
      state.enableProximitySensor = action.payload;
    },
    setPoolCover(state, action) {
      state.poolCover = action.payload;
    },
    setPoolCoverValue(state, action) {
      state.poolCover.value = action.payload;
    },
    setPoolCoverMode(state) {
      state.poolCover.mode = state.poolCover.mode === 1 ? 0 : 1;
    },
    setPoolCoverPower(state, action) {
      state.poolCover.power = action.payload;
    },
    setPolarizationCycleDuration(state, action) {
      state.polarizationCycleDuration = action.payload;
    },
    setDelayAfterCalChlorinatorValue(state) {
      state.delayAfterCal.chlorinator.value = !state.delayAfterCal.chlorinator.value;
    },
    setDelayAfterCalChlorinatorBooleanValue(state, action) {
      state.delayAfterCal.chlorinator.value = action.payload;
    },
    setDelayAfterCalChlorinatorDelay(state, action) {
      state.delayAfterCal.chlorinator.delay = action.payload;
    },
    setDelayAfterCalAddPumpValue(state) {
      state.delayAfterCal.addPump.value = !state.delayAfterCal.addPump.value;
    },
    setDelayAfterCalAddPumpBooleanValue(state, action) {
      state.delayAfterCal.addPump.value = action.payload;
    },
    setDelayAfterCalAddPumpDelay(state, action) {
      state.delayAfterCal.addPump.delay = action.payload;
    },
    setIsChlorinatorAlarm(state, action) {
      state.isChlorinatorAlarm = action.payload;
    },
    setModomisura(state, action) {
      state.modomisura = action.payload;
    },
    setEnabledLowSalt(state, action) {
      state.enabledLowSalt = action.payload;
    },
    setLowSalt(state, action) {
      state.lowSalt = action.payload;
    },
    setEnabledTmanut(state, action) {
      state.enabledTmanut = action.payload;
    },
    setTmanut(state, action) {
      state.tmanut = action.payload;
    },
    setOpenMaintenanceModal(state, action) {
      state.openMaintenanceModal = action.payload;
    },
    setIce(state, action) {
      state.ice = action.payload;
    },
    setIceTemperature(state, action) {
      state.ice.temperature = action.payload;
    },
    setIceEnabled(state, action) {
      state.ice.enabled = action.payload;
    },
    setIceUnit(state, action) {
      state.ice.unit = action.payload;
    },
    setOverDosing(state, action) {
      state.overDosing = action.payload;
    },
    setOverDosingEnabled(state, action) {
      state.overDosing.enabled = action.payload;
    },
    setOverDosingValue(state, action) {
      state.overDosing.value = action.payload;
    },
    setUnderDosing(state, action) {
      state.underDosing = action.payload;
    },
    setUnderDosingEnabled(state, action) {
      state.underDosing.enabled = action.payload;
    },
    setUnderDosingValue(state, action) {
      state.underDosing.value = action.payload;
    },
    setEnabledPostBoost(state, action) {
      state.enabledPostBoost = action.payload;
    },
  },
});

export const deviceSettingsActions = deviceSettingsSlice.actions;

export default deviceSettingsSlice;
